import React, { useState } from 'react';
import { products } from '../data/products';
import { useCart } from '../context/CartContext';
import { Plus } from 'lucide-react';
type Category = 'cortes' | 'extras';
const tabs: {
  id: Category;
  label: string;
}[] = [{
  id: 'cortes',
  label: 'Cortes Premium'
}, {
  id: 'extras',
  label: 'Extras & Carbón'
}];
export function ProductCatalog() {
  const [activeCategory, setActiveCategory] = useState<Category>('cortes');
  const {
    addToCart
  } = useCart();
  const filteredProducts = products.filter(p => p.category === activeCategory);
  return <section id="catalogo" className="bg-pitch py-16 md:py-24 px-4 md:px-8" data-id="element-192">
      <div className="max-w-7xl mx-auto" data-id="element-193">
        <div className="mb-10" data-id="element-194">
          <p className="text-[9px] uppercase tracking-[0.3em] text-fire font-semibold mb-4" data-id="element-195">
            — Catálogo completo
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-ink leading-tight" data-id="element-196">
            Todo para el <em className="text-fire not-italic italic" data-id="element-197">Asado</em>
          </h2>
        </div>

        {/* Tabs */}
        <div className="flex gap-0 border-b border-ink/10 mb-10" data-id="element-198">
          {tabs.map(tab => <button key={tab.id} onClick={() => setActiveCategory(tab.id)} className={`px-5 py-3.5 text-[10px] uppercase tracking-[0.18em] font-medium transition-all relative ${activeCategory === tab.id ? 'text-ink' : 'text-muted hover:text-ink'}`} data-id="element-199">
              {tab.label}
              {activeCategory === tab.id && <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-fire" data-id="element-200" />}
            </button>)}
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-px bg-ink/5" data-id="element-201">
          {filteredProducts.map(product => <div key={product.id} className="group bg-pitch flex flex-col overflow-hidden" data-id="element-202">
              <div className="relative h-36 md:h-44 overflow-hidden" data-id="element-203">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-204" />
                <button onClick={() => addToCart(product)} className="absolute bottom-2 right-2 bg-fire text-white p-1.5 opacity-0 group-hover:opacity-100 translate-y-1 group-hover:translate-y-0 transition-all duration-300" aria-label="Agregar al carrito" data-id="element-205">
                  <Plus className="w-3.5 h-3.5" data-id="element-206" />
                </button>
              </div>
              <div className="p-4 flex flex-col flex-1" data-id="element-207">
                <div className="flex justify-between items-start gap-2 mb-1.5" data-id="element-208">
                  <h3 className="text-xs font-heading font-bold text-ink leading-tight" data-id="element-209">
                    {product.name}
                  </h3>
                  <span className="text-fire font-bold text-xs flex-shrink-0" data-id="element-210">
                    ${product.price.toFixed(2)}
                  </span>
                </div>
                <p className="text-muted text-[11px] font-light leading-relaxed line-clamp-2 mb-3 flex-1" data-id="element-211">
                  {product.description}
                </p>
                <button onClick={() => addToCart(product)} className="w-full py-2 border border-ink/15 text-muted text-[9px] uppercase tracking-[0.15em] hover:border-fire hover:text-fire transition-colors" data-id="element-212">
                  Agregar
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}